import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'index.css';
import App from './App';
import TagManager from 'react-gtm-module';

// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// GTMの初期化
const tagManagerArgs = {
  gtmId: 'GTM-M2FPTXXH' // あなたのGTM IDに置き換えてください
};
TagManager.initialize(tagManagerArgs);

root.render(
  <React.StrictMode>
    <BrowserRouter basename={process.env.REACT_APP_BASE_PATH}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
